<template>
    <!-- Tab panes -->
    <div class="tab-content">
        <div class="container progress-bar active">
            <ul class="bar-chart-list">
                <li class="bar-chart-item resource-item-box" >
                    <div class="resource-top-row">
                        <span class="label">
                            {{ account.name | stripHtml }}
                            <i class="tooltip-icon"
                               @click="showDescription"
                               v-if="account && account.description && account.description.length > 2"
                            ></i>
                        </span>
                        <span class="upper-text text-right d-block value">
                            <strong>{{ account.balance }} / {{ account.initialBalance }} {{ account.unit }}</strong>
                        </span>
                    </div>
                    <div class="down-text text-left tooltip-description" v-if="account && account.description && account.description.length > 2 && description">
                        <button type="button" class="close" @click="hideDescription">
                            <span class="close-span" aria-hidden="true">&times;</span>
                        </button>
                        {{ account.description | stripHtml }}
                    </div>

                    <div class="progress">
                        <div class="progress-bar bg-danger"
                             :style="width"
                        ></div>
                    </div>
                    <div class="resource-bottom-row">
                        <span class="down-text text-left d-block duration">
                            {{ $t('pages.spentResources.tab1.titleBottomRight') }}
                            : {{ account.expiryDate | date }}
                        </span>
                        <div class="resource-group-info" v-if="account.group && account.group.name">
                            <img v-if="account.group.icon" :src="account.group.icon" :alt="account.group.name" class="resource-group-icon" />
                            <span class="resource-group-label">{{ account.group.name }}</span>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import Loyalty from './Loyalty';
export default Loyalty;
</script>
